/* eslint-disable unicorn/no-null */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Calendar } from 'primereact/calendar';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';

export const publicationFilterTemplate = (options: any, object: any) => {
  const publicationOptions = object
    .map((b: { publicationCode: any }) => b.publicationCode)
    .filter((value: any, index: any, self: any | any[]) => self.indexOf(value) === index);
  return (
    <MultiSelect
      value={options.value}
      options={publicationOptions}
      onChange={(event) => options.filterCallback(event.value)}
      placeholder="Select Publication"
    />
  );
};

export const countryFilterTemplate = (options: any, object: any) => {
  const countryOptions = object
    .map((b: { countryCode: any }) => b.countryCode)
    .filter((value: any, index: any, self: any | any[]) => self.indexOf(value) === index);
  return (
    <MultiSelect
      value={options.value}
      options={countryOptions}
      onChange={(event) => options.filterCallback(event.value)}
      placeholder="Select Country"
    />
  );
};

export const checkBoxFilterTemplate = (options: any) => {
  return <TriStateCheckbox value={options.value} onChange={(event) => options.filterCallback(event.value)} />;
};

export const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
  return (
    <Calendar
      value={options.value}
      onChange={(event) => options.filterCallback(event.value, options.index)}
      dateFormat="dd/mm/yy"
      placeholder="dd/mm/yyyy"
      mask="99/99/9999"
    />
  );
};

export const bookabilityFilterTemplate = (options: any, object: any) => {
  const bookabilityOptions = object
    .map((b: { bookability: any }) => b.bookability)
    .filter((value: any, index: any, self: any | any[]) => self.indexOf(value) === index);
  return (
    <MultiSelect
      value={options.value}
      options={bookabilityOptions}
      onChange={(event) => options.filterCallback(event.value)}
      placeholder="Select bookability"
    />
  );
};

export const statusFilterTemplate = (options: any, object: any) => {
  const statusOptions = object
    .map((b: { status: any }) => b.status)
    .filter((value: any, index: any, self: any | any[]) => self.indexOf(value) === index);
  return (
    <MultiSelect
      value={options.value}
      options={statusOptions}
      onChange={(event) => options.filterCallback(event.value)}
      placeholder="Select status"
    />
  );
};
